module.exports = __webpack_public_path__ + "static/img/101535.6676a254.png";